module.exports = __webpack_public_path__ + "img/top-banner-dark.36db8cdc.png";